export const CORRELATION_CHART_DATA = 'correlation_chart_data';
export const CORRELATION_TABLE_DATA = 'correlation_table_data';
export const OPTIMIZATION_CHART_DATA = 'optimization_chart_data';
export const G5_CHART_DATA = 'g5_chart_data';
export const SIMULATION_DATA = 'simulation_data';
export const SIMULATION_VALUE = 'simulation_value';
export const MULTIPLE_API_DATA = 'multiple_api_data';